import { validateResponseHasSchema } from '@/shared/api/validation'
import { createCoreApiClient } from '@/shared/api/client'
import { z } from 'zod'
import { validateSchema } from '@/shared/validation'
import { productSchema } from '@/features/projects/schemas'

const client = createCoreApiClient()

export const fetchProducts = () => validateResponseHasSchema(
  client.sendGet('organisations/2/products'),
  z.object({
    data: z.array(
      z.object({
        Id: z.number(),
        Name: z.string()
      })
    )
  })
).then(
  res => validateSchema(
    res.data.map(x => ({ id: x.Id, name: x.Name })),
    z.array(productSchema)
  )
)
